import axios from "infra/http";
import { useQuery } from "react-query";
import { FormFornecedorImposto } from 'core/features/fornecedores/typings/index';

function useGetImposto(id?: string) {
    return useQuery(
        `/v1/fornecedor/${id}/impostos`,
        async () => {
            const res = await axios.get<FormFornecedorImposto[]>(`/v1/fornecedor/${id}/impostos`);

            return res.data;
        },
        {
            enabled: !!id,
        }
    );
}

export default useGetImposto;
